import {useState} from 'react';
import PropTypes from 'prop-types';
import {Link, useSearchParams} from 'react-router-dom';
import {isValidEmail, MAX_EMAIL_LENGTH, MAX_PASSWORD_LENGTH} from '../validation';

export default function LoginScreen({onLogin}) {
    const [searchParams] = useSearchParams();
    const verifiedStatus = searchParams.get('verified') || null;
    const resetStatus = searchParams.get('reset') || null;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (!isValidEmail(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        setSubmitting(true);
        try {
            const res = await fetch('/api/v1/auth/login', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                credentials: 'same-origin',
                body: JSON.stringify({email, password}),
            });
            if (res.status === 403) {
                setError('Please verify your email before signing in.');
                return;
            }
            if (res.status >= 500) {
                setError('Server is unavailable. Please try again later.');
                return;
            }
            if (!res.ok) {
                setError('Invalid email or password');
                return;
            }
            const data = await res.json();
            onLogin(data.username, data.userID);
        } catch {
            setError('Login failed. Please try again.');
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="login-screen">
            <form className="login-form" onSubmit={handleSubmit} noValidate>
                <h2 className="login-title">Sign in</h2>
                {verifiedStatus === 'success' ? (
                    <p className="login-success">Email verified! You can now sign in.</p>
                ) : verifiedStatus === 'error' ? (
                    <p className="login-error">Invalid or expired verification link.</p>
                ) : resetStatus === 'success' ? (
                    <p className="login-success">Password reset! You can now sign in.</p>
                ) : null}
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    maxLength={MAX_EMAIL_LENGTH}
                    onChange={e => setEmail(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    maxLength={MAX_PASSWORD_LENGTH}
                    onChange={e => setPassword(e.target.value)}
                />
                <button className="login-button" type="submit" disabled={!email || !password || submitting}>
                    {submitting ? 'Signing in...' : 'Sign in'}
                </button>
                <p className="login-register-link">
                    New here? <Link to="/register">Create an account</Link>
                </p>
                <p className="login-register-link">
                    Forgot your password? <Link to="/forgot-password">Reset it</Link>
                </p>
            </form>
        </div>
    );
}

LoginScreen.propTypes = {
    onLogin: PropTypes.func.isRequired,
};
